import { addHoverEffect, mouse } from '../components/mouse'
import k from '../constants/k'
import { potions } from '../constants/potions'
import { w, h, score, times, ingredients, inCauldron } from '../state/globals'

k.loadSprite('completed-background', 'sprites/backgrounds/completed.png')
k.loadFont('font', 'fonts/pixel.ttf')

k.loadSprite('continue-button', 'sprites/ui/continue.png')
k.loadSprite('quit-button', 'sprites/ui/quit.png')

const calculateScore = () => {
  const time = (times.endTime - times.startTime) / 1000 / 60
  const timeBonus = Math.max(0, 10 - time) * 50
  const totalScore =
    500 + score.potionsMade * 50 + timeBonus - score.mistakes * 100

  return Math.round(totalScore)
}

const resetGame = () => {
  potions.forEach((potion) => {
    potion.found = false
  })
  ingredients.length = 0
  inCauldron.length = 0
  score.ingredientsFound = 0
  score.potionsMade = 0
  score.mistakes = 0
  times.startTime = null
  times.endTime = null
}

export default () => {
  k.add([k.sprite('completed-background'), k.area(), 'background'])

  const { cursor } = mouse()
  const finalScore = calculateScore()

  k.add([
    k.text(`score: ${finalScore}`, {
      size: 12,
      font: 'font'
    }),
    k.anchor('center'),
    k.pos(w / 2, 55),
    k.color(231, 109, 138)
  ])

  const continueButton = k.add([
    k.sprite('continue-button'),
    k.area(),
    k.anchor('center'),
    k.pos(w - 28, h - 12)
  ])
  const quitButton = k.add([
    k.sprite('quit-button'),
    k.area(),
    k.anchor('center'),
    k.pos(w - 28, h - 32)
  ])

  continueButton.onClick(() => {
    k.go('room')
  })
  addHoverEffect(continueButton, cursor)

  quitButton.onClick(() => {
    resetGame()
    k.go('menu')
  })
  addHoverEffect(quitButton, cursor)
}
